import libraryApi from './api'

let intervalId = 0

export default (
    tokenStorage,
    userStorage,
    tokenTiming,
    companyStorage,
    environment,
    apiInstance,
    oauthInstance,
    libraryServicesApi
) => {
    const library = {}
    const api = libraryApi(apiInstance, oauthInstance, libraryServicesApi)

    library.login = (clientId, clientSecret) => (username, password, keepMeLoggedIn, cpf) => {
        return api
            .login(clientId, clientSecret)(username, password, cpf)
            .then(({ data: { expires_in, refresh_token, access_token } }) => {
                tokenStorage.setAccessToken(access_token)
                return api.currentUser(access_token).then((data) => {
                    const expiresAt = tokenTiming.getExpiresAt(expires_in)
                    const isStayConnected = keepMeLoggedIn ? 'yes' : 'no'
                    const { email } = data.data.data
                    tokenStorage.updateAccessTokenConfig(
                        expiresAt,
                        refresh_token,
                        email,
                        clientId,
                        clientSecret,
                        isStayConnected
                    )
                    window.location.replace('/v2/home')
                    return data.data.data
                })
            })
    }

    library.loginWithCognito = (token, clientId, clientSecret) => {
        return api.loginWithCognito(token).then(({ data }) => {
            const { access_token, expires_in, refresh_token } = data
            tokenStorage.setAccessToken(access_token)
            return api.currentUser(access_token).then(({ data: { data } }) => {
                const expiresAt = tokenTiming.getExpiresAt(expires_in)
                const isStayConnected = 'yes'
                const { email } = data
                tokenStorage.updateAccessTokenConfig(
                    expiresAt,
                    refresh_token,
                    email,
                    clientId,
                    clientSecret,
                    isStayConnected
                )
                return getCountdown()
            })
        })
    }

    library.logout = () => {
        return api.logout().finally(() => {
            logoutRoutine()
        })
    }

    library.refreshAccessTokenWhenIsToStayConnected = () => {
        if (isAccessTokenConfigSet() && isToStayConnected()) {
            return refreshAccessToken().then(() => {
                reloadPage()
            })
        } else {
            logoutRoutine()
        }
    }

    library.refreshAccessTokenOnTimeout = () => {
        if (isAccessTokenConfigSet() && !isCountdownLessThanZero()) {
            intervalId = setInterval(() => {
                return refreshAccessToken().then(() => {
                    library.refreshAccessTokenOnTimeout()
                })
            }, getCountdown())
        }
    }

    library.forgotPassword = async (username, captcha, locale, cpf) => {
        const resp = await api.forgotPassword(username, captcha, locale, cpf)
        return resp.data.data.email
    }

    library.resetPasswordFind = (token) => {
        return api.resetPasswordFind(token)
    }

    library.resetPassword = (token, email, password) => {
        return api.resetPassword(token, email, password)
    }

    const refreshAccessToken = () => {
        if (!isAccessTokenConfigSet()) return

        const { username, clientId, clientSecret, refreshToken } = tokenStorage.getAccessTokenConfig()
        return api
            .refreshAccessToken(username, clientId, clientSecret, refreshToken)
            .then(({ data }) => {
                const { access_token, expires_in, refresh_token } = data
                tokenStorage.setAccessToken(access_token)
                const expiresAt = tokenTiming.getExpiresAt(expires_in)
                tokenStorage.updateAccessTokenConfig(expiresAt, refresh_token)
                return getCountdown()
            })
            .catch(() => {
                logoutRoutine()
            })
    }

    const logoutRoutine = () => {
        clearInterval(intervalId)
        tokenStorage.deleteAccessToken()
        tokenStorage.deleteAccessTokenConfig()
        userStorage.removeUserPermissions()
        userStorage.removeUserData()
        const redirectToLoginCallback = redirectToLogin()
        companyStorage.deleteCompanyData()
        redirectToLoginCallback()
    }

    const isCountdownLessThanZero = () => {
        return getCountdown() < 0
    }

    const getCountdown = () => {
        if (!isAccessTokenConfigSet()) return

        const { expiresAt } = tokenStorage.getAccessTokenConfig()
        return tokenTiming.getTimeLeft(expiresAt)
    }

    const isToStayConnected = () => {
        if (!isAccessTokenConfigSet()) return

        const { isStayConnected } = tokenStorage.getAccessTokenConfig()
        return isStayConnected === 'yes'
    }

    const isAccessTokenConfigSet = () => {
        return !!tokenStorage.getAccessTokenConfig()
    }

    const reloadPage = () => {
        window.location.reload()
    }

    const redirectToLogin = () => {
        if (isCompanyDataSet()) {
            const { loginUrl } = companyStorage.getCompanyData()
            if (loginUrl) {
                return () => redirectPage(loginUrl)
            }
        }
        return goToLoginPage
    }

    const isCompanyDataSet = () => {
        return !!companyStorage.getCompanyData()
    }

    const redirectPage = (to) => {
        window.location.replace(to)
    }

    const goToLoginPage = () => {
        redirectPage('/v2/login')
    }

    return library
}
